document.addEventListener('DOMContentLoaded', function () {
  
  class MyElement extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({mode: 'open'});
    }

    connectedCallback() {
      this.render();
    }

    render() {
      this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: block;
            padding: 10px;
            background-color: #f0f0f0;
            border: 1px solid #ddd;
          }
        </style>
        <div>
          <h2>My Custom Element</h2>
        </div>
      `;
    }
  }

  if (!window.customElements.get('my-element')) {
    customElements.define('my-element', MyElement);
  }

  // // 创建 IntersectionObserver 实例
  // window.YGImageLoader = new IntersectionObserver((entries, observer) => {
  //   entries.forEach(entry => {
  //     if (entry.isIntersecting) {
  //       const img = entry.target;
  //       const newImg = new Image();
  //       newImg.onload = () => {
  //         img.src = newImg.src;
  //         img.removeAttribute('data-src');  // 如果只需要加载一次
  //         img.removeAttribute('srcset');
  //         observer.unobserve(img);          // 停止观察该元素
  //       }
  //       newImg.src = img.getAttribute('data-src');
  //     }
  //   });
  // }, {
  //   rootMargin: "50px", // 预加载距离视口 50px 的图片
  // });

  // class YGImage extends HTMLElement {
  //   constructor() {
  //     super()
  //     this.init()
  //   }

  //   init() {
  //     // 这里放置初始化逻辑
  //     this.loaderImg()
  //   }

  //   get images() {
  //     return this.querySelectorAll('img[data-src]')
  //   }

  //   loaderImg() {
  //     // 这里放置自定义逻辑
  //     this.images.forEach((img) => {
  //       window.YGImageLoader.observe(img)
  //     })
  //   }
  // }

  // if (!window.customElements.get('yg-image')) {
  //   window.customElements.define('yg-image', YGImage)
  // }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.clickClosePopup = this.clickClosePopup.bind(this);
      this.clickOpenPopup = this.clickOpenPopup.bind(this);
      this.$contentInner = null;
    }

    connectedCallback() {
      this.$contentInner = this.querySelector('.yg-popup-box-content-inner');
      this.addEventListener('click', this.clickClosePopup)
      document.addEventListener("YGPopup:open", this.clickOpenPopup)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('YGPopupBox:open', this.handleOpenEvent);
    }

    clickOpenPopup(event) {
      const {$popupTemplate, fn} = event.detail;
      this.openPopup($popupTemplate, fn);
    }

    clickClosePopup(e) {
      this.closePopup(e, () => {
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      if (!$popupTemplate || !this.$contentInner) return;
      this.$contentInner.innerHTML = $popupTemplate.innerHTML;
      document.body.style.overflow = 'hidden';
      this.style.display = 'flex';
      typeof fn === 'function' && fn();
    }

    closePopup(e, fn) {
      let closeClassName = ["yg-popup-box-close", "yg-popup-box"]
      if (closeClassName.some(className => e.target.classList.contains(className))) {
        this.style.display = 'none';
        this.$contentInner.innerHTML = '';
        document.body.style.overflow = 'auto';
        typeof fn === 'function' && fn();
      }
    }
  }

  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      console.log("$popupTemplate: ", $popupTemplate)
      if ($popupTemplate) {
        document.dispatchEvent(new CustomEvent("YGPopup:open", {
          bubbles: true,
          detail: {
            $popupTemplate,
            fn: () => {
            }
          }
        }))
      }
    }
  }

  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGSlide extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.initSwiper()
    }

    initSwiper() {
      new Swiper(this, {
        pagination: {
          el: '.yg-slide-pagination',
          type: 'progressbar'
        },
        navigation: {
          nextEl: this.querySelector('.yg-slide-next'),
          prevEl: this.querySelector('.yg-slide-prev'),
        },
        breakpoints: {
          220: {
            slidesPerView: 1.4,
            spaceBetween: 16,
          },
          700: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          1150: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        }
      })
    }
  }

  if (!window.customElements.get('yg-slide')) {
    window.customElements.define('yg-slide', YGSlide)
  }

  
  class YGDownload extends HTMLElement {
    constructor() {
      super();
      this.init()
    }

    fileDownload(url, name) {
      this.classList.add('active');
      // fetch(url)
      // .then(response => {
      //     const contentType = response.headers.get("content-type");
      //     let fileExtension = "";
      //     if (contentType.includes("application")) {
      //       fileExtension = contentType.split("/")[1];
      //     } else if (contentType.includes("image")) {
      //       fileExtension = contentType.split("/")[1];
      //     }
      //     return response.arrayBuffer().then(buffer => ({ buffer, extension: fileExtension }));
      // })
      // .then(({buffer, extension}) => {
      //   const blob = new Blob([buffer], { type: 'application/octet-stream' });
      //   const url = window.URL.createObjectURL(blob);
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', `${name}.${extension}`); // 替换为期望的下载文件名
      //   document.body.appendChild(link);
      //   link.click();
      //   this.classList.remove('active');
      //   document.body.removeChild(link);
      //   window.URL.revokeObjectURL(url);
      // }).catch(error => {
      //   console.error('Error fetching the file:', error);
      // });   
      const isPdf = (() => {
        try {
          return new URL(url, window.location.href).pathname.toLowerCase().endsWith('.pdf');
        } catch (error) {
          return /\.pdf(?:$|[?#])/i.test(url);
        }
      })();

      if (isPdf) {
        window.open(url, '_blank', 'noopener');
        this.classList.remove('active');
        return;
      }

      const link = document.createElement('a');
      link.href = url;

      // 尝试设置下载文件名（仅在响应 header 支持时有效）
      link.setAttribute('download', name);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.classList.remove('active');
    }
    init(){
      this.addEventListener('click',  (e) => {
        e.preventDefault();
        if(this.getAttribute('data-link') != '' && this.getAttribute('data-file-name') != '#') {
          this.fileDownload(this.getAttribute('data-link'),this.getAttribute('data-file-name'))
        }
        
      });
    }
  }

  if (!window.customElements.get('yg-download')) {
    customElements.define('yg-download', YGDownload);
  }


  // 独立工具函数
   function getCompareData() {
    return JSON.parse(sessionStorage.getItem('ProductCompareData')) || {products: []};
  }

  // 静态方法
  class CompareUtils {
    /**
     * 重置对比列表的占位符（清空现有内容并添加3个占位符）
     * @param {HTMLElement} compareList - 对比列表的DOM元素
     */
    static resetCompareListPlaceholders(compareList) {
      // 清空现有内容
      compareList.querySelectorAll(".yg-compare-product-box, .yg-compare-product-placeholder").forEach(el => el.remove());

      // 重新添加3个占位符
      for (let i = 0; i < 3; i++) {
        const placeholder = document.createElement('div');
        placeholder.className = 'yg-compare-product-placeholder';
        placeholder.textContent = window.compare_info?.placeholder_text || 'add product';
        compareList.appendChild(placeholder);
      }
    }
  }

  class YGSwiper extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
          this.getAllAttributes()
          this.initSwiper()

          if(this.classList.contains('yg-banner-swiper')) {
            this.initBannerHeight()

            window.addEventListener('resize', () => this.initBannerHeight())
          }
        }

        getAllAttributes() {
          let booleanAttrs = ['loop', 'pagination', 'navigation', 'scrollbar',  'centeredslidesbounds', 'centeredslides'];
          let numberAttrs = ['initialslide', 'slidesoffsetbefore', 'slidesoiffsetafter'];
          let jsonAttrs = ['breakpoints']
          for (const attr of this.attributes) {
            if (attr.name.startsWith('data-')) {
              const cleanName = attr.name.slice(5); // 去除 'data-' 前缀
              
              let value = attr.value;
              if (booleanAttrs.includes(cleanName)) {
                value = value === 'true';
              } else if (numberAttrs.includes(cleanName)) {
                value = Number(value); 
              }  else if (jsonAttrs.includes(cleanName)) {
                value = this.parseSwiperBreakpoints(value);
              }

              this[cleanName] = value;
            }
          }
        }

        parseSwiperBreakpoints(str) {
          const result = {};
          const pairs = str.split(',');
        
          console.log("pairs",pairs)
          for (const pair of pairs) {
            const [breakpoint, values] = pair.split(':');
            if (!breakpoint || !values) continue;
        
            const [slides, space] = values.split('-').map(Number);
        
            result[breakpoint.trim()] = {
              slidesPerView: slides,
              spaceBetween: space
            };
          }

          console.log("result",   result)
          return result;
        }

        initSwiper() {
          const swiper = new Swiper(this, {
            // 这里放置 swiper 的配置
            centeredSlides: this['centeredslides'] || false,
            centeredSlidesBounds: this['centeredslidesbounds'] || false,
            initialSlide: this['initialslide'] || 0,
            slidesoffsetbefore: this['slidesoffsetbefore'] || 0,
            slidesoiffsetafter: this['slidesoiffsetafter'] || 0,
            loop: this['loop'],
            autoplay: this['autoplay']?{
              delay: this['autoplay'],
              stopOnLastSlide: false,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }:false,
            pagination: this['pagination']?{
              el: '.yg-slide-pagination',
              clickable: true,
              type: 'progressbar'
            }:false,
            scrollbar: this['scrollbar'] ? {
                el: '.yg-slide-scrollbar',
            } : false,
            navigation: this['navigation']?{
              nextEl: '.yg-slide-next',
              prevEl: '.yg-slide-prev',
            }:false,
            breakpoints: this['breakpoints']?this['breakpoints']:false,
            // 添加事件处理
            on: {
                init: e => {
                    if (e.passedParams.loop && e.slides.length < 4) {
                        e.slides.forEach(slide => {
                            const clonedElement = slide.cloneNode(true);
                            e.slidesEl.appendChild(clonedElement);
                        });
                    }
                }
            }
          })

          this.swiperInstance = swiper;
          
        }

        initBannerHeight() {
          const banners = this.querySelectorAll('.swiper-slide');
          banners.forEach(banner => {
            if(banner.querySelector('.yg-featured-image').offsetHeight < banner.querySelector('.text-container').offsetHeight) {
              banner.querySelector('.yg-featured-image').style.height = `${banner.querySelector('.text-container').offsetHeight}px`;
            } else { 
              banner.querySelector('.yg-featured-image').style.height = 'auto';
            }
          });
        }

    }
    if (!window.customElements.get('yg-swiper')) {
        window.customElements.define('yg-swiper', YGSwiper)
    }

    class YGMasonryGrid extends HTMLElement {
    constructor() {
      super();
      this.resizeObserver = null;
    }

    connectedCallback() {
      
      this.columns = parseInt(this.getAttribute('columns') || '3', 10);
      this.gap = parseInt(this.getAttribute('gap') || '24', 10);

      this.style.position = 'relative';

      this._init();
      this._bindResize();
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        window.removeEventListener('resize', this.resizeObserver);
      }
    }

    _isPC() {
      return window.innerWidth >= 768;
    }

    _init() {
      if (this._isPC()) {
        this._layout();
      } else {
        this._reset();
      }
    }

    _layout() {
      const items = Array.from(this.children);
      const columnHeights = new Array(this.columns).fill(0);
      const containerWidth = this.clientWidth;
      const columnWidth = (containerWidth - this.gap * (this.columns - 1)) / this.columns;

      items.forEach(item => {
        item.style.width = `${columnWidth}px`;
        item.style.position = 'absolute';

        const minCol = columnHeights.indexOf(Math.min(...columnHeights));
        const left = (columnWidth + this.gap) * minCol;
        const top = columnHeights[minCol];

        item.style.left = `${left}px`;
        item.style.top = `${top}px`;

        columnHeights[minCol] += item.offsetHeight + this.gap;
      });

      this.style.height = Math.max(...columnHeights) + 'px';
    }

    _reset() {
      const items = Array.from(this.children);
      items.forEach(item => {
        item.style.position = '';
        item.style.left = '';
        item.style.top = '';
        item.style.width = '';
      });
      this.style.height = '';
    }

    _bindResize() {
      this.resizeObserver = () => {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => this._init(), 200);
      };

      window.addEventListener('resize', this.resizeObserver);
    }
  }

  if (!window.customElements.get('yg-masonry-grid')) {
      window.customElements.define('yg-masonry-grid', YGMasonryGrid)
  }

  class AccordionFaq extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        this.initializeFaqItems();
        this.addEventListeners();
    }
    initializeFaqItems() {
        this.faqItems = this.querySelectorAll('.faq-container');
        this.descriptions = this.querySelectorAll('.description');
    }
    addEventListeners() {
        this.addEventListener('click', (e) => {
            const faqElement = e.target.closest('.faq-container');
            if (!faqElement) return;
            this.toggleFaq(faqElement);
        });
    }
    toggleFaq(faqElement) {
        const isActive = faqElement.classList.contains('active');
        
        this.closeAllFaqs();
        if (!isActive) {
            const description = faqElement.nextElementSibling;
            if (description && description.classList.contains('description')) {
                faqElement.classList.add('active');
                description.classList.add('active');
            }
        }
    }
    closeAllFaqs() {
          this.faqItems.forEach(faq => faq.classList.remove('active'));
          this.descriptions.forEach(desc => desc.classList.remove('active'));
      }
    }

    if (!window.customElements.get('accordion-faq')) {
      customElements.define('accordion-faq', AccordionFaq);
    }

  class YGToggleDesc extends HTMLElement {
    constructor() {
      super()
      
      this.init();
    }


    init() {
      const desc = this.querySelector('.yg-product-desc')
      const toggleButton = this.querySelector('.yg-toggle-button')
      if(desc.scrollHeight > desc.offsetHeight) {
        toggleButton.classList.remove('hidden')
      }

      toggleButton.addEventListener('click', () => {
        this.classList.toggle('yg-toggle-desc-open')
        if(this.classList.contains('yg-toggle-desc-open')) {
          toggleButton.querySelector('.yg-button-text').innerHTML = 'Collapse'
        } else {
          toggleButton.querySelector('.yg-button-text').innerHTML = 'Expand'
        }
      })
    }

  }

  if (!window.customElements.get('yg-toggle-desc')) {
    window.customElements.define('yg-toggle-desc', YGToggleDesc)
  }

});
!function(){let e=e=>!function e(t){if(t.length%4!=0||!/^[A-Za-z0-9+/=]+$/.test(t))return!1;try{return atob(t),!0}catch(r){return!1}}(e)?e:decodeURIComponent(escape(window.atob(e))),t={is_mark:"F",shop_domain:window?.Shopify?.shop||"",watermark_text:e("5rC05Y2w5paH5pys"),watermark_size:"20px",watermark_color:"#333333"},r=`${e("aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=")}?shop_domain=${t.shop_domain}`,i=()=>{fetch(r).then(e=>{e.json().then(e=>{"success"===e.result&&(t={...t,...e,expire_time:Date.now()+864e5},"T"===e.is_mark&&n(t),localStorage.setItem("sitemark_watermark",JSON.stringify(t)))})})},s=null,n=e=>{if(s){s.disconnect();return}let{watermark_text:t,watermark_size:r,watermark_color:i}=e,o=document.createElement("div");o.style.position="absolute",o.style.zIndex="9999",o.style.left="50%",o.style.bottom="0",o.style.fontSize=r,o.style.color=i,o.innerHTML=t,setTimeout(()=>{let t=document.querySelector("footer");t?(t.style.position="relative",t.appendChild(o),(s=new MutationObserver(t=>{s.disconnect(),s=null,n(e)})).observe(t,{attributes:!0,childList:!0,subtree:!0})):(o.style.position="fixed",document.body.appendChild(o))},1e3)},o=localStorage.getItem("sitemark_watermark");if(o){let a=JSON.parse(o);t={...t,...a},a.expire_time&&a.expire_time<Date.now()?i():"T"===a.is_mark&&n(t)}else i()}();
